var _circle, _path, _path2, _path3, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _g, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlSupportLeft(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 641,
    height: 284,
    viewBox: "0 0 641 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 258,
    r: 24,
    fill: "#B4D2FF",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289.56 260.12C290.974 260.12 292.12 258.974 292.12 257.56C292.12 256.146 290.974 255 289.56 255C288.146 255 287 256.146 287 257.56C287 258.974 288.146 260.12 289.56 260.12Z",
    fill: "#0859A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M299.564 260.12C300.977 260.12 302.124 258.974 302.124 257.56C302.124 256.146 300.977 255 299.564 255C298.15 255 297.003 256.146 297.003 257.56C297.003 258.974 298.15 260.12 299.564 260.12Z",
    fill: "#0859A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M309.631 260.12C311.045 260.12 312.191 258.974 312.191 257.56C312.191 256.146 311.045 255 309.631 255C308.217 255 307.071 256.146 307.071 257.56C307.071 258.974 308.217 260.12 309.631 260.12Z",
    fill: "#0859A4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 60,
    r: 50,
    fill: "#B4D2FF",
    fillOpacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 467,
    cy: 185,
    r: 41,
    fill: "#B4D2FF",
    fillOpacity: 0.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 86,
    r: 21,
    fill: "#B4D2FF",
    fillOpacity: 0.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 166,
    r: 10,
    fill: "#B4D2FF",
    fillOpacity: 0.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 10,
    r: 10,
    fill: "#B4D2FF",
    fillOpacity: 0.3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 20,
    r: 10,
    fill: "#B4D2FF",
    fillOpacity: 0.3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 620,
    cy: 184,
    r: 21,
    fill: "#B4D2FF",
    fillOpacity: 0.3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 411,
    cy: 90,
    r: 33,
    fill: "#B4D2FF",
    fillOpacity: 0.3
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 176,
    r: 108,
    fill: "#B4D2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 68,
    width: 216,
    height: 216
  }, _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 176,
    r: 108,
    fill: "#D7E7FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.786 153.622H117.372L107.66 113.838H154.074L163.786 153.622Z",
    fill: "#AFCDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.361 257.374C118.361 257.374 217.552 199.971 241.847 192.9C266.142 185.829 311.931 292.102 311.931 292.102L281.292 290.701C281.292 290.701 250.379 250.458 241.847 246.457C233.315 242.457 203.016 272.231 203.016 272.231L118.361 257.374Z",
    fill: "#003A5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.263 121.814L233.441 115.852C233.441 115.852 231.867 105.174 245.246 98.4191C245.246 98.4191 250.135 96.4278 252.895 100.416C255.441 104.089 248.054 103.427 248.447 109.711C248.841 115.995 245.86 119.686 241.71 121.731L238.276 125.707L230.263 121.814Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.796 107.487C103.796 107.487 115.291 163.888 178.531 182.323C198.271 188.076 243.117 123.078 243.117 123.078C243.117 123.078 241.543 117.116 231.664 118.463C231.664 118.463 187.998 147.373 182.501 150.515C177.618 153.299 145.537 114.695 130.918 108.465C116.299 102.234 103.796 107.487 103.796 107.487Z",
    fill: "#43A379"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.375 105.434L215.167 117.108L273.897 108.09L272.104 96.416L213.375 105.434Z",
    fill: "#0D7FD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.118 110.338L207.714 114.028C207.799 114.57 207.989 115.09 208.274 115.558C208.56 116.027 208.935 116.434 209.378 116.758C209.82 117.081 210.323 117.314 210.856 117.443C211.389 117.572 211.942 117.595 212.484 117.51L215.203 117.093L213.414 105.413L210.433 105.872C209.921 105.946 209.429 106.12 208.985 106.385C208.541 106.649 208.154 106.999 207.846 107.415C207.537 107.83 207.314 108.302 207.19 108.803C207.065 109.305 207.041 109.827 207.118 110.338Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.981 237.245C81.981 237.245 194.544 253.522 248.215 269.071C301.885 284.62 347.256 289.848 347.256 289.848C347.256 289.848 344.871 306.649 341.067 309.028C341.067 309.028 219.716 312.099 190.627 307.836C169.921 304.819 141.977 297.104 121.736 300.342C121.599 300.342 121.468 300.389 121.33 300.419C116.562 301.328 111.649 301.15 106.959 299.898C102.268 298.645 97.921 296.351 94.24 293.186C90.5591 290.021 87.6395 286.066 85.6987 281.616C83.7579 277.166 82.8458 272.336 83.0303 267.485L81.981 237.245Z",
    fill: "#065AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0098 94.3948C96.0098 94.3948 124.359 108.107 140.725 103.004C137.616 99.3937 133.864 96.3917 129.659 94.1503C130.226 90.8712 130.667 88.0214 130.918 85.6067C131.309 82.7123 131.54 79.7983 131.609 76.8783L120.657 68.2929L110.283 60.0593C111.1 83.198 96.0098 94.3948 96.0098 94.3948Z",
    fill: "#EAAEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0682 240.447C81.0027 242.182 84.7111 244.161 86.3447 244.906C98.4834 250.23 109.799 253.945 122.624 255.185C137.773 256.729 155.689 253.325 161.854 253.45C162.482 253.437 163.085 253.196 163.547 252.77C163.988 252.46 164.304 234.198 163.988 211.233C163.988 210.303 163.988 209.372 163.929 208.442V208.138C163.804 199.159 163.488 189.751 163.046 180.343C162.164 159.667 160.53 139.73 157.764 128.712C154.431 115.715 146.889 107.106 140.039 100.857L134.381 95.9029C128.442 97.1886 122.243 96.4476 116.775 93.7983C110.217 90.6443 103.199 87.24 102.067 88.1045C93.517 94.3527 87.7577 108.375 84.6514 126.363C82.8196 137.616 81.9559 149.006 82.0699 160.406C82.0699 164.866 82.2011 169.445 82.4515 173.964C83.9599 198.48 82.4515 219.77 81.5691 232.094C81.3187 235.683 81.104 238.467 81.0682 240.447Z",
    fill: "#6ACEA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0688 239.32C138.304 209.898 99.8851 131.586 99.8851 131.586L83.7876 126.364C82.4559 138.439 81.8328 150.583 81.9215 162.732C81.9215 167.502 82.0109 172.384 82.1957 177.214C83.2987 203.411 81.7008 226.162 81.0688 239.32Z",
    fill: "#43A379"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.092 68.889C110.092 68.889 117.246 81.9458 130.899 85.5827C131.291 82.6882 131.522 79.7743 131.591 76.8542L120.657 68.2928L110.092 68.889Z",
    fill: "#AF706B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.581 76.5027C136.581 76.5027 109.531 80.9266 106.992 64.2985C104.452 47.6703 99.2409 37.04 116.418 33.5105C133.594 29.9809 137.881 35.8297 140.129 41.1776C142.376 46.5256 143.551 74.9228 136.581 76.5027Z",
    fill: "#EAAEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.5 115.536C233.5 115.536 232.57 111.864 235.116 110.212C237.662 108.561 240.011 104.065 241.078 104.673C243.302 105.931 239.886 109.855 240.482 114.743C240.72 116.46 236.714 120.944 233.5 115.536Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.458 249.289C60.458 249.289 62.9799 267.885 64.542 270.502C66.104 273.119 72.7398 281.466 75.5718 283.106C78.4037 284.745 72.7457 267.324 73.3181 264.868C73.8905 262.411 75.6493 269.357 76.8953 269.518C78.1414 269.679 77.8194 263.425 77.8671 261.171C77.9148 258.918 71.7978 253.272 69.6455 248.425C67.4932 243.577 60.458 249.289 60.458 249.289Z",
    fill: "#EAAEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.079 87.9674C102.079 87.9674 84.9618 96.0699 76.7581 108.531C64.0291 127.854 49.2731 198.283 49.0048 204.806C48.7365 211.328 59.7722 257.373 59.7722 257.373C59.7722 257.373 70.9689 256.634 73.8605 250.982C73.8605 250.982 71.6188 203.673 73.0378 200.632C74.4567 197.591 119.721 137.172 114.635 124.276C109.549 111.38 102.079 87.9674 102.079 87.9674Z",
    fill: "#6ACEA5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.786 153.622H117.372L107.66 113.838H154.074L163.786 153.622Z",
    fill: "#AFCDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.361 257.374C118.361 257.374 217.552 199.971 241.847 192.9C266.142 185.829 311.931 292.102 311.931 292.102L281.292 290.701C281.292 290.701 250.379 250.458 241.847 246.457C233.315 242.457 203.016 272.231 203.016 272.231L118.361 257.374Z",
    fill: "#003A5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.796 107.487C103.796 107.487 115.291 163.888 178.531 182.323C198.271 188.076 243.117 123.078 243.117 123.078C243.117 123.078 241.543 117.116 231.664 118.463C231.664 118.463 187.998 147.373 182.501 150.515C177.618 153.299 145.537 114.695 130.918 108.465C116.299 102.234 103.796 107.487 103.796 107.487Z",
    fill: "#43A379"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0098 94.3948C96.0098 94.3948 124.359 108.107 140.725 103.004C137.616 99.3937 133.864 96.3917 129.659 94.1503C130.226 90.8712 130.667 88.0214 130.918 85.6067C131.309 82.7123 131.54 79.7983 131.609 76.8783L120.657 68.2929L110.283 60.0593C111.1 83.198 96.0098 94.3948 96.0098 94.3948Z",
    fill: "#EAAEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0682 240.447C81.0027 242.182 84.7111 244.161 86.3447 244.906C98.4834 250.23 109.799 253.945 122.624 255.185C137.773 256.729 155.689 253.325 161.854 253.45C162.482 253.437 163.085 253.196 163.547 252.77C163.988 252.46 164.304 234.198 163.988 211.233C163.988 210.303 163.988 209.372 163.929 208.442V208.138C163.804 199.159 163.488 189.751 163.046 180.343C162.164 159.667 160.53 139.73 157.764 128.712C154.431 115.715 146.889 107.106 140.039 100.857L134.381 95.9029C128.442 97.1886 122.243 96.4476 116.775 93.7983C110.217 90.6443 103.199 87.24 102.067 88.1045C93.517 94.3527 87.7577 108.375 84.6514 126.363C82.8196 137.616 81.9559 149.006 82.0699 160.406C82.0699 164.866 82.2011 169.445 82.4515 173.964C83.9599 198.48 82.4515 219.77 81.5691 232.094C81.3187 235.683 81.104 238.467 81.0682 240.447Z",
    fill: "#6ACEA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0688 239.32C138.304 209.898 99.8851 131.586 99.8851 131.586L83.7876 126.364C82.4559 138.439 81.8328 150.583 81.9215 162.732C81.9215 167.502 82.0109 172.384 82.1957 177.214C83.2987 203.411 81.7008 226.162 81.0688 239.32Z",
    fill: "#43A379"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.092 68.889C110.092 68.889 117.246 81.9458 130.899 85.5827C131.291 82.6882 131.522 79.7743 131.591 76.8542L120.657 68.2928L110.092 68.889Z",
    fill: "#AF706B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.581 76.5027C136.581 76.5027 109.531 80.9266 106.992 64.2985C104.452 47.6703 99.2409 37.04 116.418 33.5105C133.594 29.9809 137.881 35.8297 140.129 41.1776C142.376 46.5256 143.551 74.9228 136.581 76.5027Z",
    fill: "#EAAEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1599 31.5252C102.919 23.6017 115.97 15.5708 136.7 17.2163C164.018 19.3746 158.676 43.8786 146.311 44.5821C135.579 45.1783 133.874 40.9512 127.28 41.4759C120.686 42.0006 119.44 51.516 117.204 52.8038C114.969 54.0916 115.851 51.7962 112.822 50.419C109.793 49.0417 109.513 54.0617 110.384 57.323C111.254 60.5842 107.105 64.8769 107.105 64.8769L102.931 60.3576C98.7577 55.8324 94.7751 36.6764 96.6829 32.5924C96.8201 32.2526 96.987 31.8889 97.1599 31.5252Z",
    fill: "#002538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.079 87.9674C102.079 87.9674 84.9618 96.0699 76.7581 108.531C64.0291 127.854 49.2731 198.283 49.0048 204.806C48.7365 211.328 59.7722 257.373 59.7722 257.373C59.7722 257.373 70.9689 256.634 73.8605 250.982C73.8605 250.982 71.6188 203.673 73.0378 200.632C74.4567 197.591 119.721 137.172 114.635 124.276C109.549 111.38 102.079 87.9674 102.079 87.9674Z",
    fill: "#6ACEA5"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M281.56 67.1202C282.974 67.1202 284.12 65.974 284.12 64.5601C284.12 63.1462 282.974 62 281.56 62C280.146 62 279 63.1462 279 64.5601C279 65.974 280.146 67.1202 281.56 67.1202Z",
    fill: "#0859A4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M291.564 67.1202C292.977 67.1202 294.124 65.974 294.124 64.5601C294.124 63.1462 292.977 62 291.564 62C290.15 62 289.003 63.1462 289.003 64.5601C289.003 65.974 290.15 67.1202 291.564 67.1202Z",
    fill: "#0859A4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M301.631 67.1202C303.045 67.1202 304.191 65.974 304.191 64.5601C304.191 63.1462 303.045 62 301.631 62C300.217 62 299.071 63.1462 299.071 64.5601C299.071 65.974 300.217 67.1202 301.631 67.1202Z",
    fill: "#0859A4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M559.56 46.1202C560.974 46.1202 562.12 44.974 562.12 43.5601C562.12 42.1462 560.974 41 559.56 41C558.146 41 557 42.1462 557 43.5601C557 44.974 558.146 46.1202 559.56 46.1202Z",
    fill: "#0859A4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M569.564 46.1202C570.977 46.1202 572.124 44.974 572.124 43.5601C572.124 42.1462 570.977 41 569.564 41C568.15 41 567.003 42.1462 567.003 43.5601C567.003 44.974 568.15 46.1202 569.564 46.1202Z",
    fill: "#0859A4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M579.631 46.1202C581.045 46.1202 582.191 44.974 582.191 43.5601C582.191 42.1462 581.045 41 579.631 41C578.217 41 577.071 42.1462 577.071 43.5601C577.071 44.974 578.217 46.1202 579.631 46.1202Z",
    fill: "#0859A4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M507.56 239.12C508.974 239.12 510.12 237.974 510.12 236.56C510.12 235.146 508.974 234 507.56 234C506.146 234 505 235.146 505 236.56C505 237.974 506.146 239.12 507.56 239.12Z",
    fill: "#0859A4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M517.564 239.12C518.977 239.12 520.124 237.974 520.124 236.56C520.124 235.146 518.977 234 517.564 234C516.15 234 515.003 235.146 515.003 236.56C515.003 237.974 516.15 239.12 517.564 239.12Z",
    fill: "#0859A4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M527.631 239.12C529.045 239.12 530.191 237.974 530.191 236.56C530.191 235.146 529.045 234 527.631 234C526.217 234 525.071 235.146 525.071 236.56C525.071 237.974 526.217 239.12 527.631 239.12Z",
    fill: "#0859A4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8043 85.7904C83.9074 87.9513 82.8778 90.1383 81.722 92.32C76.6637 101.866 61.6816 124.891 31.8862 132.526C17.3993 136.234 6.96921 133.884 2.51046 125.9C-5.41626 111.7 7.25631 83.7108 32.6353 59.3677C7.51675 88.3313 -2.10951 113.43 4.30332 124.921C8.2702 131.972 16.982 131.454 30.4761 128.003C59.4684 120.575 71.155 101.073 76.085 91.7704C82.2284 80.229 86.3941 68.7585 84.8997 62.0585C84.0933 58.4273 82.4563 55.9171 78.4812 55.0306C66.4311 52.346 44.4175 61.3939 29.8735 73.6164C44.0514 59.391 66.0642 50.1334 78.9263 53.0131C83.5758 54.0513 86.7741 56.6623 88.1792 60.5623C90.2904 66.3631 88.9421 75.8214 84.8043 85.7904Z",
    fill: "#4FAA83"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 183,
    fill: "white",
    transform: "translate(49 17)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlSupportLeft);
export default __webpack_public_path__ + "static/media/il_support_left.b5a4df6b.svg";
export { ForwardRef as ReactComponent };